"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Telephone = function Telephone(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size;
  var iconSize = size === 'original' ? 'width="24" height="24"' : size;
  var title = 'Telephone Icon';
  return "\n    <svg xmlns=\"http://www.w3.org/2000/svg\" aria-label=\"".concat(title, "\" ").concat(iconSize, " viewBox=\"0 0 24 24\">\n        <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n        <path\n            d=\"M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z\"\n            fill=\"#ffffff\"\n        />\n    </svg>\n  ");
};

var _default = Telephone;
exports["default"] = _default;